import {MenuItem} from "@mui/material";
import {PriceMatrixSources, PriceMatrixTypes} from "../../../../../../../components/dialogs/upsert-price-matrix";
import {ImportingDataTypes} from "../../types";
import {createInvalidCustomerCodeSection, createInvalidPartSection, PreventionInvalidityCode,} from "./shared";

const priceMatrixTypeOptions = Object.values(PriceMatrixTypes).map((t) => ({
    value: t.title,
    label: t.title,
}));

const priceMatrixBasedOnOptions = Object.values(PriceMatrixSources).map((s) => ({
    value: s.title,
    label: s.title,
}));

export const preventativeInteraction = {
    datasourceId: ImportingDataTypes.priceMatrices,
    sections: [
        createInvalidPartSection("target"),
        createInvalidCustomerCodeSection("customerCode"),
        {
            sectionKey: "missingPriceMatrixFields",
            sectionTitle: "Missing Required Price Matrix Fields",
            invalidityCode: PreventionInvalidityCode.MISSING_REQUIRED_FIELDS,
            fields: [
                {
                    key: "type",
                    label: "Type",
                    type: "input",
                    textFieldProps: {
                        select: true,
                        SelectProps: {
                            renderValue: (selected) => {
                                const match = priceMatrixTypeOptions.find((e) => e.value === selected);
                                return match ? match.label : selected;
                            },
                        },
                        children: priceMatrixTypeOptions.map((e) => (
                            <MenuItem key={e.value} value={e.value}>
                                {e.label}
                            </MenuItem>
                        )),
                    },
                    extractValue: (o) => (typeof o === "string" ? o : o?.value),
                    modifyRow: (row, val) => ({...row, type: val}),
                },
                {
                    key: "target",
                    label: "Target",
                    type: "input",
                    extractValue: (o) => (typeof o === "string" ? o : o?.partNo ?? o?.partNumber ?? null),
                    modifyRow: (row, val) => ({...row, target: val}),
                },
                {
                    key: "change",
                    label: "Change",
                    type: "input",
                    textFieldProps: {
                        type: "number",
                    },
                    modifyRow: (row, val) => ({...row, change: val}),
                },
                {
                    key: "basedOn",
                    label: "Based on",
                    type: "input",
                    textFieldProps: {
                        select: true,
                        SelectProps: {
                            renderValue: (selected) => {
                                const match = priceMatrixBasedOnOptions.find((e) => e.value === selected);
                                return match ? match.label : selected;
                            },
                        },
                        children: priceMatrixBasedOnOptions.map((e) => (
                            <MenuItem key={e.value} value={e.value}>
                                {e.label}
                            </MenuItem>
                        )),
                    },
                    extractValue: (o) => (typeof o === "string" ? o : o?.value),
                    modifyRow: (row, val) => ({...row, basedOn: val}),
                },
                {
                    key: "startDate",
                    label: "Start Date",
                    type: "text",
                    modifyRow: (row, val) => ({...row, startDate: val}),
                },
                {
                    key: "endDate",
                    label: "End Date",
                    type: "text",
                    modifyRow: (row, val) => ({...row, endDate: val}),
                },
                createInvalidCustomerCodeSection("customerCode").fields[0],
            ],
        },
    ],
};
